<div class="navbar">
    <a mat-menu-item [routerLink]="['/main/dashboard']" [ngClass]="active('dashboard') ? 'active' : ''">
        <mat-icon>dashboard</mat-icon>
        <span>Dashboard</span>
    </a>
    <a mat-menu-item [routerLink]="['/main/pending-payment-requests']" [ngClass]="active('pending-payment-requests') ? 'active' : ''">
        <mat-icon>money</mat-icon>
        <span>Pending Payment Requests</span>
    </a>
    <a mat-menu-item [routerLink]="['/main/transactions']" [ngClass]="active('transactions') ? 'active' : ''">
        <mat-icon>history</mat-icon>
        <span>Transactions History</span>
    </a>
</div>
